import api from 'store/api';
import replaceApiIri from 'helpers/replaceApiIri';
import { setErrorCatch } from 'store/status/actions';
import handleInvalidateTags from './handleInvalidateTags';
import {
  ProjectMember,
  ProjectMemberPatchMutation,
  ProjectMemberPostMutation,
} from './interfaces';

export const projectMembersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    addProjectMember: builder.mutation<
      ProjectMember,
      ProjectMemberPostMutation
    >({
      query: (body) => ({
        url: '/project-members',
        method: 'POST',
        body,
      }),
      invalidatesTags: (args) => handleInvalidateTags(args),
    }),
    updateProjectMember: builder.mutation<
      ProjectMember,
      ProjectMemberPatchMutation
    >({
      query: ({ id, ...body }) => ({
        url: `/project-members/${id}`,
        headers: { 'content-type': 'application/merge-patch+json' },
        method: 'PATCH',
        body: JSON.stringify(body),
      }),
      invalidatesTags: (args) => handleInvalidateTags(args),
    }),
    deleteProjectMember: builder.mutation<
      void,
      { id: string; project: string }
    >({
      query: ({ id }) => ({
        url: `/project-members/${id}`,
        method: 'DELETE',
      }),
      async onQueryStarted({ project }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(
            api.util.invalidateTags([
              { type: 'Projects', id: +replaceApiIri(project, 'projects') },
              { type: 'Projects', id: 'LIST' },
            ]),
          );
        } catch (error) {
          dispatch(setErrorCatch(error));
        }
      },
    }),
  }),
});

export const {
  useAddProjectMemberMutation,
  useUpdateProjectMemberMutation,
  useDeleteProjectMemberMutation,
} = projectMembersApi;
